import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export function Terms() {
  return (
    <div className="min-h-screen bg-slate-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-xl p-8">
        <div className="mb-8">
          <Link to="/" className="inline-flex items-center text-sm text-blue-600 hover:text-blue-800">
            <ArrowLeft className="w-4 h-4 mr-1" />
            Voltar para Home
          </Link>
        </div>

        <h1 className="text-3xl font-bold text-slate-900 mb-8">Termos de Uso (EULA)</h1>
        
        <div className="prose prose-slate max-w-none">
          <p className="mb-4">Última atualização: {new Date().toLocaleDateString()}</p>

          <h2 className="text-xl font-semibold mt-6 mb-4">1. Aceitação dos Termos</h2>
          <p className="mb-4">
            Ao acessar e usar este aplicativo, você aceita e concorda em ficar vinculado aos termos e disposições deste contrato. 
            Além disso, ao usar os serviços deste aplicativo, você estará sujeito a quaisquer regras ou diretrizes publicadas aplicáveis a tais serviços.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">2. Licença de Uso</h2>
          <p className="mb-4">
            Concedemos a você uma licença limitada, não exclusiva e intransferível para usar nosso aplicativo estritamente de acordo com os termos deste contrato.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">3. Restrições</h2>
          <p className="mb-4">
            Você concorda em não, e não permitirá que outros:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Licenciar, vender, alugar, arrendar, ceder, distribuir, transmitir, hospedar, terceirizar, divulgar ou explorar comercialmente o aplicativo.</li>
            <li>Modificar, fazer trabalhos derivados, desmontar, descriptografar, compilar ou fazer engenharia reversa de qualquer parte do aplicativo.</li>
            <li>Remover, alterar ou ocultar qualquer aviso de propriedade (incluindo qualquer aviso de direitos autorais ou marca registrada) da GeoRanking ou de suas afiliadas.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-4">4. Isenção de Garantias</h2>
          <p className="mb-4">
            O aplicativo é fornecido "como está" e "conforme disponível" e com todas as falhas e defeitos, sem garantia de qualquer tipo. 
            Na extensão máxima permitida pela lei aplicável, a GeoRanking renuncia expressamente a todas as garantias, sejam expressas, implícitas, estatutárias ou outras.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">5. Limitação de Responsabilidade</h2>
          <p className="mb-4">
            Em nenhum caso a GeoRanking será responsável por quaisquer danos especiais, incidentais, indiretos ou consequentes de qualquer tipo.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">6. Contato</h2>
          <p className="mb-4">
            Se você tiver alguma dúvida sobre estes Termos, entre em contato conosco:
          </p>
          <p className="font-medium">
            Email: marcoamlevy@gmail.com
          </p>
        </div>
      </div>
    </div>
  );
}
